var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReverseLeft = function SvgReverseLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.202 18.5V17h6.177q1.564 0 2.694-1.034t1.129-2.552q0-1.52-1.129-2.549t-2.694-1.029H5.358L8.14 12.62l-1.054 1.054L2.5 9.086 7.087 4.5 8.14 5.554 5.358 8.336h11.02q2.196 0 3.76 1.465 1.564 1.464 1.564 3.613 0 2.147-1.565 3.617T16.38 18.5z"
  })));
};
export default SvgReverseLeft;